import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import * as _ from 'lodash';
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class RequestService {

  constructor(
    private http: HttpClient,
    private localStorageService: LocalStorageService,
  ) { }

  getUrl(urlEndpoint: string): string {
    const apiUrlLocalStorage = environment.ENVIRONMENT !== 'production' ? this.localStorageService.apiUrl : undefined;
    if(!_.isEmpty(apiUrlLocalStorage)) return apiUrlLocalStorage + urlEndpoint;
    return environment.API_URL + urlEndpoint
  }

  parseUrlQueryParams(url: string, options: any): string {

    const urlQueryParams: any = options || {};
    Object.entries(urlQueryParams).forEach(([key, value]) => {
      url += (_.indexOf(url, '?') > 0 ? '&' : '?') + key + '=' + value;
    });

    return url;
  }

  get(urlEndpoint:string, criteria?: any): Promise<any> {
    let url = this.getUrl(urlEndpoint)

    if(!_.isEmpty(criteria)) {
      url = this.parseUrlQueryParams(url, criteria);
    }

    return this.http.get(url).toPromise();
  }

  put(urlEndpoint:string, body: any): Promise<any> {
    const url = this.getUrl(urlEndpoint)
    return this.http.put(url, body).toPromise();
  }

  post(urlEndpoint:string, body: any, options?: any): Promise<any> {
    const url = this.getUrl(urlEndpoint)
    return this.http.post(url, body, options).toPromise();
  }

  delete(urlEndpoint:string): Promise<any> {
    const url = this.getUrl(urlEndpoint);
    return this.http.delete(url).toPromise();
  }

  streamPost(
    urlEndpoint: string,
    body: Record<string, unknown> | FormData,
    options: {
      headers: Record<string, string>;
      signal?: AbortSignal;
    }
  ): Promise<Response> {
    const url = this.getUrl(urlEndpoint);

    return fetch(url, {
      method: 'POST',
      headers: options.headers,
      body: body instanceof FormData ? body : JSON.stringify(body),
      signal: options?.signal
    });
  }
}
